import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { Form } from 'semantic-ui-react'
import { DateInput } from 'semantic-ui-calendar-react'
import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'
import { getCorrectLanguageCode } from '~/utils/helpers'
import { FieldComponentProps } from './types'
import { LabelWithInfo } from '../util'

const BirthDateField: React.FC<FieldComponentProps> = ({ field, name, disabled }) => {
  const { control } = useFormContext()
  const { t } = useTranslation()
  const languageStored = localStorage.getItem('i18nextLng')
  const maxDate = dayjs().subtract(18, 'year').format('DD.MM.YYYY')
  const minDate = dayjs().subtract(90, 'year').format('DD.MM.YYYY')
  const required = !disabled && Boolean(field.fieldRequired)

  return (
    <Controller
      control={control}
      name={`${name}.value`}
      rules={disabled ? {} : {
        ...(required ? { required: t('Please enter date of birth') } : {}),
        validate: (value) => {
          const age = dayjs().diff(dayjs(value, 'DD.MM.YYYY'), 'year')
          if (age < 18) return t('You must be at least 18 years old')
          if (age > 90) return t('Date of birth is not valid')
          return true
        }
      }}
      render={({ field: f, fieldState }) => (
        <Form.Field error={Boolean(fieldState.error)}>
          <label><LabelWithInfo label={field.label} info={field.info} required={required} /></label>
          <DateInput
            name={`${name}.value`}
            placeholder='tt.mm.jjjj'
            value={f.value || ''}
            disabled={disabled}
            dateFormat='DD.MM.YYYY'
            iconPosition='left'
            closable
            localization={getCorrectLanguageCode(languageStored)}
            minDate={minDate}
            maxDate={maxDate}
            initialDate={maxDate}
            autoComplete='new-password'
            onChange={(e, { value }) => f.onChange(value)}
          />
        </Form.Field>
      )}
    />
  )
}

export default BirthDateField
